import styled from 'styled-components'
import { colors, media } from 'client/styles'

export const HotelPreviewBase = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: ${colors.white};
  border: 2px solid ${colors.grey4};
  border-radius: 8px;

  padding-block: 20px;
  padding-inline: 20px;

  ${media.tablet} {
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 600px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding-block-start: 0;

  ${media.tablet} {
    flex-wrap: nowrap;
  }
`
export const RowHotelName = styled(Row)`
  margin-block-start: 20px;
  align-items: flex-start;
  flex-direction: column;

  ${media.tablet} {
    flex-direction: row;
    align-items: center;
  }
`

export const ImageBoxLeft = styled.div`
  height: 180px;
  width: 100%;
  background-color: ${colors.grey5};
  border-radius: 8px;
  overflow: hidden;

  ${media.tablet} {
    width: 330px;
  }
`

export const ImageMap = styled(ImageBoxLeft)`
  margin-block-start: 20px;
  margin-inline-start: 0;

  ${media.tablet} {
    margin-inline-start: 20px;
    margin-block-start: 0;
  }
`

export const HotelName = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  margin-block-end: 13px;

  color: ${colors.grey1};
  ${media.tablet} {
    font-size: 34px;
    margin-block-end: 0;
  }
`

export const HotelAddress = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  margin-block-start: 12px;

  text-decoration-line: underline;

  color: ${colors.grey2};
  max-width: 100%;
`

export const HotelRating = styled.div`
  height: 100%;
  padding-inline-start: 0;
  ${media.tablet} {
    padding-inline-start: 18px;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  ${props => `background-image: url(${props.src})`};
  ${props => !props.src && `background-color:${colors.grey5}`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`
